var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-body"},[_c('page-header',{attrs:{"propButtons":_vm.page.buttons,"propConfig":_vm.page.header,"propModel":_vm.dataModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }